import type { User, Workspace } from "@/types";

/** Placeholder only — real identity comes from /api/auth/session.php. */
export const mockUser: User = {
  id: "",
  name: "",
  email: "",
  role: "CEO",
  initials: "",
};

/** Workspace label — not business CRM data. */
export const mockWorkspace: Workspace = {
  id: "ws_opera",
  name: "Cyberweb OPERA",
  plan: "Operating System",
};
